import React from 'react';
import Pagination from '@mui/material/Pagination';
import { styled } from '@mui/material';

const StyledPagination = styled('div')(({ theme }) => ({
  '& > * + *': {
    marginTop: theme.spacing(2),
  },
}));

interface Props {
  count: number;
  page: number;
  onChange: (event: React.ChangeEvent<unknown>, page: number) => void;
}

const PaginationControlled: React.FC<Props> = ({ count, page, onChange }) => {
  return (
    <StyledPagination>
      <Pagination count={count || 10} page={page} onChange={onChange} />
    </StyledPagination>
  );
};

export default PaginationControlled;
